// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary-button {
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    justify-content: center;
    text-align: center;
    width: 190px;
    height: 49px;
    background-color: purple;
    transition-duration: 0.5s;
    border-radius: 10px;
}

.primary-button:hover {
    background-color: transparent;
    border-color: purple;
    color: #000000;
    border-width: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/PrimaryBtn/PrimaryBtn.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".primary-button {\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    justify-content: center;\n    text-align: center;\n    width: 190px;\n    height: 49px;\n    background-color: purple;\n    transition-duration: 0.5s;\n    border-radius: 10px;\n}\n\n.primary-button:hover {\n    background-color: transparent;\n    border-color: purple;\n    color: #000000;\n    border-width: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
